// src/router/config.ts

export const routerConfig = {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }
  };